var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"banner__main"},[_c('img',{staticClass:"banner__left",attrs:{"src":require("@/assets/imon/Group 6286@2x.png"),"alt":""}}),_c('img',{staticClass:"banner__right",attrs:{"src":require("@/assets/imon/组 1@2x.png"),"alt":""}})])])
}]

export { render, staticRenderFns }